<app-main-loader *ngIf="showLoader"></app-main-loader>
<app-header (toggleTextDirectionEvent)="onToggleTextDirection()"></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
